import { Box, Toggle } from '@openfin/ui-library';
import { Field, FieldProps } from 'formik';
import React from 'react';
import styled from 'styled-components';
import { BooleanField, ToggleWidgetSpec } from '../../../../../client';

interface Props {
  field: BooleanField<ToggleWidgetSpec>;
}

export const ToggleWidgetComponent = (props: Props): JSX.Element => {
  const { key, label } = props.field;
  return (
    <Field name={key}>
      {({ field }: FieldProps) => (
        <Wrapper>
          <Toggle {...field} checked={field.value} label={label} labelSide="right" />
        </Wrapper>
      )}
    </Field>
  );
};

const Wrapper = styled(Box)`
  width: 100%;
`;
